<template>
    <a :id="id" :href="`${linkUrl}`" class="return-nav-link" data-toggle="modal">
        <span>
            <i :class="getIconClass" />
            {{ linkLabel }}
        </span>
    </a>
</template>

<script>
export default {
	props: ['linkUrl', 'linkLabel', 'type', 'id'],
	computed: {
		getIconClass() {
			const icons = {
				arrowRight: 'icon icon-arrow-right',
				download: 'download-data'
			};
			return this.type ? icons[this.type] : '';
		}
	}
};
</script>
<style lang='less' scoped>
.return-nav-link {
    margin-left: auto;
    margin-top: auto;
    margin-bottom: auto;
    text-transform: uppercase;
    font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}

.arrow-wrapper {
    display: inline-block;
    overflow: hidden;

    .arrow {
        color: #878a96;
        font-size: 28px;
        margin-left: -20px;
        line-height: 15px;
    }
}
</style>